class ProductMatcher extends HTMLElement {

    constructor() {
        super();


        this.states = {
            loading: 'loading',
            active: 'active',
            initial: 'initial',
            bestChoice: 'best-choice',
            showRecommendation: 'show-recommendation',
            noResults: "no-results",
            inModal: 'form-mounted-in-modal'
        }
        

        this.selectors = {
            productItem: '.product-matcher-recommendation-item'
        }

        this.activeProductHandle = this.dataset.productHandle;
        this.productSectionId = this.dataset.productSectionId;

    
        this.container = this.querySelector('.js-product-matcher-widget');
        this._containerHome   = this.container.parentNode;
        this._containerAnchor = document.createComment('product-matcher-form-anchor');

        this.recommendationContainer = this.querySelector('.js-product-matcher-recommendations-container')
        this.recommendationList = this.querySelector('.js-product-matcher-recommendations');
        this.productModal = document.querySelector('.js-product-details-modal-wrapper');

        this.modalRecommendationList = this.productModal?.querySelector('.js-modal--product-matcher-recommendation-list');
        this.form = this.querySelector('form');
        this.inputContainer = this.querySelector('.js-product-matcher-input-container');
        this.input = this.querySelector('.js-product-matcher-input');
        this.statusText = this.querySelector('.js-product-matcher-status-text');

        this.refinedSearch = "";
        this.searchId = "";

        this.fetchCtrl = null;

        this.PRODUCT_LIMIT = 4;

        //init analytics service
        this.INTER_URL = `${window.theme.apiUrl}/api/ai/search/analytics/interaction`;
        this.IMP_URL = `${window.theme.apiUrl}/api/ai/search/analytics/impression`;

        this.analyticsService = new window.AnalyticsService({
            impressionUrl: this.IMP_URL,
            interactionUrl: this.INTER_URL,
            idleMs: 15000,
            currency: window.theme?.currency || 'USD'
        });

        this.analyticsService.configureImpressions({
            container: this.modalRecommendationList,
            limit: this.PRODUCT_LIMIT,
            productItemSelector: this.selectors.productItem,
            loadingClass: "loading"
        });
        

        this.init();
    }

    init(){
        this.setupEventListeners();

        //track recommendation views
        this.recommendationList.addEventListener('click', this.handleQVClick.bind(this));
    }

    setupEventListeners(){
        this.input.addEventListener('focus', this.handleInputFocus.bind(this));
        this.input.addEventListener('input', this.inputAutoSize.bind(this));
        this.input.addEventListener('keydown', this.handleKeyDown.bind(this));
        this.input.addEventListener('blur', this.handleInputBlur.bind(this));
        this.form.addEventListener('submit', this.handleSubmit.bind(this));

        /* MODAL EVENT LISTENERS */
        if(this.productModal){
            this.productModal.addEventListener('productDetailsModal:close', this._restoreFormToPage.bind(this));
        }
    }

    inputAutoSize(event) {
        const el = this.input;
        el.style.height = 'auto';                 // reset
        el.style.height = `${el.scrollHeight}px`; // fit content
    }

    handleKeyDown(event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.handleSubmit(event);
        }  
    }

    handleInputFocus(){
        this.container.dataset.state = this.states.active
    }

    handleInputBlur() {
        if (this.input.value == "") {
            this.changeState('initial');
        }
    }

    handleSubmit(e){
        e.preventDefault();
        this.startSearch();

        const search_url = `${window.theme.apiUrl}/api/ai/search/peek`;
        
        const query = this.input.value;

        const locale = (window.theme.apiLocale || 'us').toLowerCase();

        //omit search id for search because it's a new search
        const params = new URLSearchParams({
            search: query,
            locale: locale.toLowerCase(),
            placement: "productMatcher",
            originProductHandle: this.activeProductHandle
        }).toString();
        
        const ctrl = this.fetchCtrl;
        fetch(`${search_url}?${params}`, {
            credentials: 'include',
            signal: ctrl.signal
        })
        .then(r => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
        })
        .then((results) => {
            this.handleResults(results);
        })
        .catch(err => {
            if (err.name === 'AbortError') return;

            this.changeState('initial')
            console.log(err.message);
        })
        .finally(() => {
            this.resetSearch();
        })
    }

    startSearch(){
        if (this.fetchCtrl) this.fetchCtrl.abort();   // cancel leftovers

        this.fetchCtrl = new AbortController();

        this.changeState('loading')

        //make sure input is visible
        this.input.style.display = "block";
        this.input.disabled = true;

        //remove status text
        this.statusText.style.display = "none";

        //destroy carousel first
        if (window.Flickity && this.recommendationList) {
            const flInst = window.Flickity.data(this.recommendationList);
            if (flInst) flInst.destroy();
        }

        //clear product results
        this.recommendationList.innerHTML = "";
        if(this.modalRecommendationList) this.modalRecommendationList.innerHTML = "";

        //hide recommendations
        this.recommendationContainer.style.display = "none";

        //remove open classlist to input container
        this.inputContainer.classList.remove('js-product-info-modal-open');

        //reset analytics
        this.resetAnalyticsService();
    }

    resetSearch(){
        this.input.disabled = false;
    }

    handleResults(results){

        const {
            products = [],
            search, 
            searchId,
            title
        } = results;

        if(search == "no results" || products.length == 0){
            this.handleNoResults()
            return;
        }

        //set variables
        this.searchId = searchId;
        this.refinedSearch = search;

        //set searchid for analytics
        this.analyticsService.setSearchId(searchId);


        //find matching product from top 5
        const top5Products = products.slice(0, 5);
        
        // find the product in the same list/order used for display
        const idxInTop5 = top5Products.findIndex(p => this.activeProductHandle === p.handle);
        const matchingProduct = idxInTop5 !== -1 ? top5Products[idxInTop5] : null;


        //sort the top5 by bestSElling 30d
        //const sortedTop5 = top5Products.sort((a, b) => a.salesRank30d - b.salesRank30d);
        const sortedTop5 = top5Products;

        if(!matchingProduct || this.classList.contains(this.states.inModal)){
            this.handleProductResults(sortedTop5.slice(0, 4), title);
            this.changeState('show-recommendation');

            //init analytics for impression
            this.analyticsService.observeItemsInPage(0);

            //init carousel when recommendations are shown
            //this.initRecommendationCarousel();

            /*
            this.analyticsService.sendPeekImpression(0, {
                start: 0,
                end: 0 // we are only showing 1 product for now but it should be this.PRODUCT_LIMIT - 1
            })
            */

            this._mountFormIntoModal();

        }else{
            this.changeState('best-choice')
            this.getProductAnswer();
            console.log('best-choice');
            //init analytics for product
            const productSection = (window.sections?.instances || []).find(i => i.id === this.productSectionId);
            productSection?.initSearchIdAnalytics?.(this.searchId);

            // send impression for the specific index within the visible list
            this.analyticsService.sendPeekImpression(0, {
                start: idxInTop5,
                end: idxInTop5
            });

            //also add click analytic
            this.analyticsService.trackClick(matchingProduct.handle || "");
        }

        

    }

    handleQVClick(event){
      const qvTrigger = event.target.closest('.js-open-qv');
      if (qvTrigger) {
        this.handleRecommendationView(qvTrigger);
        // your logic here
      }
    }

    handleRecommendationView(element){
      const handle = element.dataset.handle;

      this.analyticsService.trackClick(handle)
    
    }

    resetAnalyticsService() {
        //reset impressions
        this.analyticsService.resetImpressions();
        this.analyticsService.setSearchId(null);
    }

    handleNoResults(){
        this.changeState('no-results')
    }

    getProductAnswer(){
        const productPageModalContent = document.querySelector('.product-modal-content .js-product-matcher-selected-info-text')

        if(!productPageModalContent || !this.activeProductHandle || !this.searchId) return

        const data = {
            handle: this.activeProductHandle,
            searchId: this.searchId
        }

        this.inputContainer.classList.add('js-product-info-modal-open');
        productPageModalContent.classList.add('loading')
        productPageModalContent.innerHTML = `<div class="skeleton-description">
              <div class="skeleton-line short"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
            </div>`

        const ctrl = this.fetchCtrl;

        fetch(`${window.theme.apiUrl}/api/ai/search/analytics/productAnswer`, {
            credentials: 'include',
            signal: ctrl.signal,
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then((res) => res.json())
        .then((response) => {
          const answer = response.answer;
          const descriptionElement = productPageModalContent;
          
          //append answer to description element. Append asterisk at the end
          descriptionElement.innerHTML = `${answer}*`;

        })
        .finally(() => {
            productPageModalContent.classList.remove('loading');
        })
        .catch( err => {
          console.log(err);
          descriptionElement.innerHTML = ``;
          this.inputContainer.classList.remove('js-product-info-modal-open');
        })
    }

    handleProductResults(products = [], title = ""){

        const titleElement = document.createElement('h4');
        titleElement.classList.add('product-matcher-recommendation-search-title');
        titleElement.innerHTML = `${title}`
        this.modalRecommendationList.appendChild(titleElement)

        products = products.slice(0, 3)

        products.forEach((product, i) => {
            const { handle, featuredImage = null } = product
            const amount = Number.parseFloat(product.priceRangeV2?.minVariantPrice.amount).toFixed(2) || 0;
            let money    = slate.Currency.formatMoney(
                                amount.toString(),
                                theme.moneyFormat
                            )

            const imgUrl = `${product.featuredImage?.url}&width=200`;

            const label2 = product.metafields?.label_2 || false;

            const title = product.metafields?.alternate_product_title || product.title

            const template = `
            <a class="product-matcher-recommendation-item-link js-open-qv"
                data-handle="${handle}"
                data-ai-query="${this.refinedSearch}"
                data-ai-search-id="${this.searchId}"
                href="${window.routes.root_url}/products/${handle}">


                <div class="product-matcher-recommendation-image-container">
                    <span class="product-matcher-rank">#${i + 1}</span>
                    <img height="100" width="100" loading="lazy" src="${imgUrl}">
                </div>
                <div class="product-matcher-recommendation-content">
                    <h3 class="product-matcher-recommendation-title">${title}</h3>
                    ${label2 ? `<p class="product-matcher-recommendation-text">${label2}</p>`: "" }
                    <div class="product-matcher-recommendation-price price"><span class="money">${money}</span></div>
                    <span class="product-matcher-recommendation-learn-more btn__underline-animation">Learn More</span>
                </div>
            </a>
            `

            const block = document.createElement('div');
            block.dataset.index = i;
            block.classList.add('product-matcher-recommendation-item', 'carousel-cell');
            block.innerHTML = template;
                
            this.modalRecommendationList.appendChild(block);

            if(i == 0){
                // make a deep clone (copies children)
                const clone = block.cloneNode(true);

                clone.classList.add('js-product-info-modal-open');
                clone.dataset.tab = "product_matcher_show_recommendation"
                clone.querySelector('.product-matcher-recommendation-item-link').classList.remove('js-open-qv');
                this.recommendationList.appendChild(clone);

                //triigger click to open modal
                clone.click();

                clone.addEventListener('click', this._mountFormIntoModal.bind(this));
            }
            //this.recommendationList.appendChild(block);

            
            
            
        })

        
        
        
    }

    initRecommendationCarousel() {
        const carousel = this.recommendationList;
        if (carousel) {
            const initFlickity = () => {
                const flkty = new Flickity(carousel, {
                    imagesLoaded: true,
                    wrapAround: false,
                    pageDots: true,
                    contain: true,
                    cellAlign: "left",
                    prevNextButtons: false
                });

                const prev = this.recommendationContainer.querySelector(".flickity-prev");
                const next = this.recommendationContainer.querySelector(".flickity-next");

                // ---- show/hide logic
                const updateArrows = () => {
                    const total = flkty.slides ? flkty.slides.length : 0;
                    const atFirst = flkty.selectedIndex === 0;
                    const atLast  = flkty.selectedIndex === total - 1;

                    if (prev) {
                    const hidePrev = total <= 1 || atFirst;
                    prev.classList.toggle("is-hidden", hidePrev);
                    prev.setAttribute("aria-disabled", String(hidePrev));
                    }
                    if (next) {
                    const hideNext = total <= 1 || atLast;
                    next.classList.toggle("is-hidden", hideNext);
                    next.setAttribute("aria-disabled", String(hideNext));
                    }
                };

                // helper: send impression for a single index
                const sendIdxImpression = (idx) => {
                    this.analyticsService.sendPeekImpression(0, { start: idx, end: idx });
                };

                flkty.on("select", () => {
                    //console.log('flickity index:', flkty.selectedIndex)
                    updateArrows();
                    sendIdxImpression(flkty.selectedIndex);
                });


                if (prev && next) {
                    prev.addEventListener("click", () => flkty.previous());
                    next.addEventListener("click", () => flkty.next());
                }
            };

            if (window.theme && window.theme.whenFlickityReady) {
                window.theme.whenFlickityReady(initFlickity);
            } else if (window.Flickity) {
                initFlickity();
            }
        }
    }

    changeState(type){
        if(!type) return;
        
        const container = this.container;
        const input = this.input;
        const states = this.states;

        switch(type){
            case "initial":
                container.dataset.state = states.initial;
                break;
            case "loading":
                container.dataset.state = states.loading;
                
                break;
            case "best-choice":
                container.dataset.state = states.bestChoice;
                input.style.display = "none";
                this.statusText.style.display = "flex";
                break;
            case "show-recommendation":
                container.dataset.state = states.showRecommendation;
                this.recommendationContainer.style.display = "block";
                break;
            case "no-results":
                container.dataset.state = states.noResults;
                break;
        }

    }

    // when opening the recommendations modal
    _mountFormIntoModal() {
        const modalFormContainer = this.productModal?.querySelector('.js-product-matcher-modal-form--fixed');

        if (!modalFormContainer) return;
    
        // park a marker where the form originally lived, then move the node
        if (this._containerHome && !this._containerAnchor.parentNode && !this.classList.contains('form-mounted-in-modal')) {
            this._containerHome.replaceChild(this._containerAnchor, this.container);

            modalFormContainer.appendChild(this.container);
            this.classList.add(this.states.inModal);

            //remove value of input by default when you open the modal and set state to initial;
            this.input.value = "";
            this.changeState('initial');
        }
        
    }

    // when closing the modal
    _restoreFormToPage() {
        console.log('restore form');

        if (this._containerAnchor?.parentNode) {
            this._containerAnchor.replaceWith(this.container); 
        }

        this.classList.remove(this.states.inModal);
        this.inputAutoSize();
        this.fetchCtrl?.abort();
    }

}

customElements.define('product-matcher', ProductMatcher);
